import Modal from 'developer_components/newModal';
import EventEmitter from 'methods/eventEmitter';
import Select from 'components/select';
import {createElement, generateHash} from 'methods/utils';
import IMask from 'imask';
import {isGoogleMail, isGoogleRegistrationBlockedResponse, showGoogleMailBlockedLegacyModal, bindGoogleRegistrationBlockedPopupHandler} from 'components/authorization-modal/google-auth-blocked';

/**
 * Модалка регистрации
 */
function RegistrationModal() {
    // наследуемся
    EventEmitter.call(this);

    this.modal_id  = 'registration';
    this._$element = Modal.createFromHTML(
        `<div class="Registration-modal container">
            <div class="background"></div>
            <div class="form">
                <div class="form-header">
                    <div class="mobile-wrapper">
                        <div class="logo"></div>
                        <button class="close-button js-modalClose"></button>
                    </div>
                    <div class="cross-wrapper"><div class="cross js-modalClose"></div></div>
                </div>
                <div class="form-content">
                    <div class="header-title">Регистрация</div>
                    <form action="/users_v2/registration/" method="post" class="fields">
                        <div class="field">
                            <span class="title">Профиль</span>
                            <div class="Select-wrapper">
                                <div class="Select" data-name="profile_type">
                                    <div class="Select-selected-wrapper">
                                        <div class="Select-selected">Турист</div>
                                        <div class="Select-arrow"></div>
                                    </div>
                                    <div class="Select-items">
                                        <div class="Select-item" data-value="1">Отельер</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="field-wrapper js-fieldWrapper"></div>

                        <button class="button">Зарегистрироваться</button>
                    </form>
                    <div class="socials">
                        <span class="js-social social vk" data-url="https://oauth.vk.com/authorize?client_id=6252553&redirect_uri=${location.origin}/users_v2/auth/vk/&scope=4194305&display=mobile"></span>
                        <span class="js-social social yandex" data-url="https://oauth.yandex.ru/authorize?response_type=code&client_id=2d0ee8b146a94a71958f6e69ae0ac1fd&redirect_uri=${location.origin}/users_v2/auth/yandex/&force_confirm=yes"></span>
                        <span class="js-social social google" data-url="https://accounts.google.com/o/oauth2/auth?redirect_uri=${location.origin}/users_v2/auth/google/&response_type=code&client_id=1086070594189-e4vlpa9g2ukhm280l2j8h9s86tfdhtce.apps.googleusercontent.com&scope=https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"></span>
                        <span class="js-social social mail" data-url="https://oauth.mail.ru/login?client_id=50c3a57533f74a4abe3f465211c0f4eb&response_type=code&redirect_uri=${location.origin}/users_v2/auth/mail/&state=${generateHash(256)}&prompt_force=1"></span>
                    </div>
                </div>
                <div class="form-footer">
                    Уже есть аккаунт? <span class="link" data-modal_id="authorization">Войти</span>
                </div>
            </div>
        </div>`,
        {
            id: this.modal_id,
        }
    );
    this._$fieldWrapper = this._$element.querySelector('.js-fieldWrapper');

    this.type_render = {
        0: `
        <div class="field" data-type="email">
            <span class="title">Адрес электронной почты</span>
            <input type="text" class="input js-emailInput" name="email" required placeholder="E-mail" autocomplete="email">
            <span class="hint" data-default-message="Мы отправим пароль для входа Вам на почту"></span>
        </div>`.trim(),
        1: `
        <div>
            <div class="field" data-type="name">
                <span class="title">Имя</span>
                <input type="text" class="input" name="name" required placeholder="Имя" autocomplete="given-name">
                <span class="hint"></span>
            </div>
            <div class="field" data-type="email">
                <span class="title">E-mail</span>
                <input type="text" class="input" name="email" required placeholder="E-mail" autocomplete="email">
                <span class="hint" data-default-message="Мы отправим пароль для входа Вам на почту"></span>
            </div>
            <div class="field" data-type="phone">
                <span class="title">Телефон</span>
                <input type="text" class="input" name="phone" required placeholder="Телефон" autocomplete="tel">
                <span class="hint"></span>
            </div>
        </div>`.trim()
    };

    // наследование
    Modal.call(this, this._$element, {
        modal_id: this.modal_id,
    });

    this._events = {
        submit: (e) => {
            e.preventDefault();
            e.stopPropagation();

            // защита от повторной отправки
            if (this._$form.classList.contains('is-loading')) {
                return false;
            }
            this._$form.classList.add('is-loading');

            const email = this._$form.elements.email?.value;
            if (isGoogleMail(email)) {
                showGoogleMailBlockedLegacyModal();
                this._$form.classList.remove('is-loading');
                return false;
            }

            // убираем ошибки
            this._$element.querySelectorAll('.field').forEach($field => {
                $field.classList.remove('error');

                let $hint = $field.querySelector('.hint');
                if ($hint) {
                    $hint.textContent = $hint.dataset.defaultMessage;
                }
            });

            fetch(this._$form.getAttribute('action'), {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: new FormData(this._$form),
            })
            .then(response => response.json())
            .then(r => {
                if (r.status === 'ok' && r.email) {
                    this.emit('success', r.email);
                } else if (isGoogleRegistrationBlockedResponse(r)) {
                    showGoogleMailBlockedLegacyModal();
                } else if (r.fields) {
                    this._$element.querySelectorAll('.field').forEach($field => {
                        let name = $field.dataset.type;

                        if (name && r.fields[name]) {
                            $field.classList.add('error');

                            let $hint = $field.querySelector('.hint');
                            if ($hint) {
                                $hint.textContent = r.fields[name];
                            }
                        }
                    });
                } else if (r.message) {
                    alert(r.message);
                }

                this._$form.classList.remove('is-loading');
            });
        }
    }

    this._renderFields = function() {
        while(this._$fieldWrapper.firstChild) {
            this._$fieldWrapper.removeChild(this._$fieldWrapper.firstChild);
        }

        let element     = createElement(this.type_render[+this._profileSelect.getValue()]);
        let $phoneInput = element.querySelector('[name="phone"]');

        // маска для телефона
        if ($phoneInput) {
            // форматирование маски под стиль JS
            const mask = '+7 (\\d{3}) \\d{3}-\\d{2}-\\d{2}'.replace(/\\d\{(\d+)\}/g, function(match, count) {
                return '0'.repeat(count);
            });

            if (!$phoneInput.value) {
                $phoneInput.value = mask.replace(/^(\+\d+)(.*)$/g, '$1');
            }

            new IMask($phoneInput, {
                mask: mask,
            });
        }

        this._$fieldWrapper.appendChild(element);

        this._$element.querySelectorAll('.field').forEach($field => {
            $field.classList.remove('error');

            let $hint = $field.querySelector('.hint');
            if ($hint) {
                $hint.textContent = $hint.dataset.defaultMessage;
            }
        });
    }

    this.init = function() {
        const $select = this._$element.querySelector('.Select[data-name="profile_type"]');
        if ($select !== null) {
            this._profileSelect = new Select($select, {
                on: {
                    change: this._renderFields.bind(this),
                },
            });
        }

        // форма
        this._$form = this._$element.querySelector('form');
        this._$form.addEventListener('submit', this._events.submit);

        // открытие модалки
        this.on('open', this._renderFields);

        /**
         * Всплывающее окно авторизации vk, fb, ok
         */
        this._winParams = {
            vk: "toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=820,height=435",
        }

        bindGoogleRegistrationBlockedPopupHandler();

        this._$element.querySelectorAll('.js-social').forEach($button => $button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            if ($button.classList.contains('google')) {
                showGoogleMailBlockedLegacyModal();
                return;
            }

            const requestURL = location.origin + location.pathname;
            const winParam = $button.classList.contains('vk') ? this._winParams.vk
                           : '';

            // создаем окно
            window.popup = window.open($button.dataset.url, "_blank", winParam);

            // создаем callback function
            window.popup_ok = function(user_type_id = 1) {
                window.popup.close();

                // отельер
                if (user_type_id == 2) {
                    location.href = '/lk/booking/';
                } else {
                    location.href = 'https://panel.privettur.ru/';
                }
            }

            // создаем callback function
            window.popup_cancel = function() {
                window.popup.close();
            }
        }));
    }
    this.init();
}

RegistrationModal.prototype = Object.create(Modal.prototype, {
    constructor: {
        value: RegistrationModal,
        enumerable: false,
        writable: true,
    }
});

export default RegistrationModal;
